export const SET_CAPSULE_LOADING = "SET_CAPSULE_LOADING";
export const RESET_CAPSULE_STATE = "RESET_CAPSULE_STATE";

export const GET_CAPSULES_REQUEST = "GET_CAPSULES_REQUEST";
export const GET_CAPSULES_SUCCESS = "GET_CAPSULES_SUCCESS";
export const GET_CAPSULES_FAIL = "GET_CAPSULES_FAIL";

export const GET_CAPSULE_REQUEST = "GET_CAPSULE_REQUEST";
export const GET_CAPSULE_SUCCESS = "GET_CAPSULE_SUCCESS";
export const GET_CAPSULE_FAIL = "GET_CAPSULE_FAIL";

export const CREATE_CAPSULE_REQUEST = "CREATE_CAPSULE_REQUEST";
export const CREATE_CAPSULE_SUCCESS = "CREATE_CAPSULE_SUCCESS";
export const CREATE_CAPSULE_FAIL = "CREATE_CAPSULE_FAIL";

export const UPDATE_CAPSULE_REQUEST = "UPDATE_CAPSULE_REQUEST";
export const UPDATE_CAPSULE_SUCCESS = "UPDATE_CAPSULE_SUCCESS";
export const UPDATE_CAPSULE_FAIL = "UPDATE_CAPSULE_FAIL";

export const DELETE_CAPSULE_REQUEST = "DELETE_CAPSULE_REQUEST";
export const DELETE_CAPSULE_SUCCESS = "DELETE_CAPSULE_SUCCESS";
export const DELETE_CAPSULE_FAIL = "DELETE_CAPSULE_FAIL";

export const GET_DOMAINES_REQUEST = "GET_DOMAINES_REQUEST";
export const GET_DOMAINES_SUCCESS = "GET_DOMAINES_SUCCESS";
export const GET_DOMAINES_FAIL = "GET_DOMAINES_FAIL";

export const GET_THEMES_BY_DOMAINE_REQUEST = "GET_THEMES_BY_DOMAINE_REQUEST";
export const GET_THEMES_BY_DOMAINE_SUCCESS = "GET_THEMES_BY_DOMAINE_SUCCESS";
export const GET_THEMES_BY_DOMAINE_FAIL = "GET_THEMES_BY_DOMAINE_FAIL";

export const setCapsuleLoading = (loading) => ({ type: SET_CAPSULE_LOADING, payload: loading });
export const resetCapsuleState = () => ({ type: RESET_CAPSULE_STATE });

export const getCapsulesRequest = () => ({ type: GET_CAPSULES_REQUEST });
export const getCapsulesSuccess = (data) => ({ type: GET_CAPSULES_SUCCESS, payload: data });
export const getCapsulesFail = (error) => ({ type: GET_CAPSULES_FAIL, payload: error });

export const getCapsuleRequest = (id) => ({ type: GET_CAPSULE_REQUEST, payload: { id } });
export const getCapsuleSuccess = (data) => ({ type: GET_CAPSULE_SUCCESS, payload: data });
export const getCapsuleFail = (error) => ({ type: GET_CAPSULE_FAIL, payload: error });

export const createCapsuleRequest = (payload) => ({ type: CREATE_CAPSULE_REQUEST, payload });
export const createCapsuleSuccess = (data) => ({ type: CREATE_CAPSULE_SUCCESS, payload: data });
export const createCapsuleFail = (error) => ({ type: CREATE_CAPSULE_FAIL, payload: error });

export const updateCapsuleRequest = (id, payload) => ({
    type: UPDATE_CAPSULE_REQUEST,
    payload: { id, payload },
});
export const updateCapsuleSuccess = (data) => ({ type: UPDATE_CAPSULE_SUCCESS, payload: data });
export const updateCapsuleFail = (error) => ({ type: UPDATE_CAPSULE_FAIL, payload: error });

export const deleteCapsuleRequest = (id) => ({ type: DELETE_CAPSULE_REQUEST, payload: { id } });
export const deleteCapsuleSuccess = (id) => ({ type: DELETE_CAPSULE_SUCCESS, payload: id });
export const deleteCapsuleFail = (error) => ({ type: DELETE_CAPSULE_FAIL, payload: error });

export const getDomainesRequest = () => ({ type: GET_DOMAINES_REQUEST });
export const getDomainesSuccess = (data) => ({ type: GET_DOMAINES_SUCCESS, payload: data });
export const getDomainesFail = (error) => ({ type: GET_DOMAINES_FAIL, payload: error });

export const getThemesByDomaineRequest = (domaineId) => ({
    type: GET_THEMES_BY_DOMAINE_REQUEST,
    payload: { domaineId },
});
export const getThemesByDomaineSuccess = (data) => ({
    type: GET_THEMES_BY_DOMAINE_SUCCESS,
    payload: data,
});
export const getThemesByDomaineFail = (error) => ({
    type: GET_THEMES_BY_DOMAINE_FAIL,
    payload: error,
});
